module.exports = __webpack_public_path__ + "img/5.353bbda8.jpeg";